<template>
  <div>
    <mall-header></mall-header>
    <mall-bread>
        <span >支付宝支付</span>
    </mall-bread>
    <div class="alipay-div" v-loading.fullscreen.lock="fullscreenLoading">
        <div>
            <!-- <img src="../../static/images/alipayLog.png" class="alipay-div-img"> -->
            <svg class="alipay-div-img" aria-hidden="false">
              <use fill="#2698E4" xlink:href="#zhifubaozhifu"></use>
            </svg>
            <span class="alipay-div-span-font" >支付宝支付</span> 
            <span class="alipay-div-span-total" >应付总额：</span>
            <span class="alipay-div-span-money">￥{{totalAmount}}</span>
         <span class="alipay-div-span-line" ></span>
        </div>
        <div>  
            <div class="alipay-div-content-div" >
                <span>收款方：</span><span style="font-weight: bold;">深圳市东宝信息技术有限公司</span>
                <br/>
                <span>订单编号：{{orderNo}}</span>
            </div>
            <div  style="float: left;">
                  <!-- <img class="alipay-div-QRCode"  src="../../static/images/SK.png"/> -->
                  <vue-qr class="alipay-div-QRCode" :logoSrc="imageUrl" :text="url" :size="400"></vue-qr>
                 <!-- <div v-if="isTimeOut" class="alipay-timeout-div" >
                    <span class="alipay-timeout-div-font"  >二维码已失效</span>
                    <el-button @click="clikRefresh()" class="alipay-timeout-div-button" >刷新二维码</el-button>
                 </div> -->
                  <img  class="alipay-div-QRCode-box" style="" src="../../static/images/扫一扫.png"/>
                  <span class="alipay-div-QRCode-font" style="">请使用支付宝扫一扫 扫描二维码完成支付</span>
            </div>
            <div>    
                <span class="alipay-div-line" ></span>
                <img class="alipay-div-index-img"  src="../../static/images/alipay.png"/>
            </div>
        </div> 
    </div>
    <div style="clear: both;height: 149px;">
      </div>
       <div style="left: 0px;bottom: 0px;width: 100%;z-index:1;text-align: center; padding: 20px 0;    color: #999999;font-size: 14px;">
      Copyright ©2021 深圳市东宝信息技术有限公司 All Rights Reserved
    </div>
  </div>
</template>
<script>
import "../assets/js/iconfont.js"
import mallHeader from '../components/header.vue'
import mallFooter from '../components/footer.vue'
import mallBread from '../components/navbread.vue'
import vueQr from 'vue-qr'
import axios from 'axios'
import http from '../api/public'
  export default{
      data(){
          return{
            orderNo:"",
            mdShow:false,
            totalAmount:"",
            orderId:"",
            refreshId:null,
            timer:null,
            screenWidth:document.body.clientWidth,
            screenHeight:document.body.clientHeight,
            isCall:false,
            fullscreenLoading:true,
            isTimeOut:false,
            destoryId:null,
            payC:false,
            payCtitle:'立即支付',
            imageUrl: require("../../static/images/组 1.jpg"),
            url:"",
          }
      },
      mounted() {
        //支付宝支付获取二维码
        this.getAliPayData();
      },
      destroyed(){
          //if(this.timer) { //如果定时器在运行则关闭
             clearInterval(this.timer);
             clearInterval(this.refreshId); 
         // }
      },
      methods: {
        //支付宝支付获取二维码
        getAliPayData() {
          let data = {
            "orderId":this.$route.query.orderId,
            "type":"2",
          }
          this.orderNo  = this.$route.query.orderNo
          let urls='/mallApi/mall/payRecord/get'
          axios.defaults.headers ={
              "content-type": "application/json",
              "token": localStorage.getItem("Authorization")
          }
          axios.post(urls,data).then((res) => {
            res = res.data;
            if(res.success) {
              this.url = res.result.payUrl;
              this.totalAmount= http.changeUnitPrice(res.result.totalAmount);
              if(!this.isCall){
                this.TimeOUT(res.result.orderId);
                this.callRefresh(res.result.orderId);
              }
              this.$message({
                showClose: true,
                message: '操作成功！',
                type: 'success'
              });
            }else{
              if(res.code == 401 ||res.code == 400) {
                 http.setLocalStorge();
                this.$router.push({path: '/login'});
              }else{
                this.$message({
                  showClose: true,
                  message: '操作失败！',
                  type: 'error'
                });
              }
              
            }
             this.fullscreenLoading = false;
          });
        },
        
        tempSet(){
          if(this.isTimeOut){
            $(".alipay-div-QRCode").attr("style","opacity:0.05");
            $(".alipay-div-QRCode-box").attr("style"," margin-top: 22px;");
            $(".alipay-div-QRCode-font").attr("style","margin-top: 20px;margin-left: -72px;");
          }
        },
        clikRefresh(){
          this.isTimeOut = false;
          this.mdShow=true;
            $(".alipay-div-QRCode").attr("style","opacity:1");
            $(".alipay-div-QRCode-box").attr("style"," margin-top: 522px;");
            $(".alipay-div-QRCode-font").attr("style","margin-top: 520px;margin-left: -188px;");
        },
         //刷新订单支付状态
        refresh(orderId){
          return new Promise((resolve, reject)=>{
              axios.get("/mallApi/mall/payRecord/queryByOrderId?orderId="+orderId).then((res) => {
                res = res.data;
                 if(res.success) {
                    if(res.code == 200){
                      this.payC =true;
                      clearInterval(this.destoryId); 
                      resolve(true)
                    }else if(res.code == 201){
                      reject(false)
                    }else{
                       clearInterval(this.destoryId); 
                    }
                 }else{
                    if(res.code == 400 || res.code == 401){
                      clearInterval(this.destoryId); 
                      http.setLocalStorge();
                      this.$router.push({path: '/login'});
                    }else if(res.code == 201){
                      reject(false)
                    }else{
                      clearInterval(this.destoryId); 
                      reject(false)
                    }
                 }
               
              }); 
          });
        },
        //刷新支付二维码
        callBack(orderId ){
           var url = '/mallApi/mall/payRecord/refresh'
          axios.defaults.headers ={
            "content-type": "application/json",
            "token": localStorage.getItem("Authorization")
          }
          var data = {
            "orderId":orderId,
            "type":"2"
            
          }
          axios.post(url,data).then((res) => {
            res = res.data;
            if(res.success) {
              this.url = res.result.payUrl;
              if(res.result.payStatus == 2 || res.result.payStatus == 3){
                clearInterval(this.refreshId); 
              }
            }else{
              if(res.code == 401 || res.code == 400) {
                http.setLocalStorge();
                clearInterval(this.refreshId); 
                this.$router.push({path: '/login'});
              }else{
                 //http.setLocalStorge();
                  clearInterval(this.refreshId); 
                // this.$message({
                //   showClose: true,
                //   message: '操作失败！',
                //   type: 'error'
                // });
              }
              
            }
          });
        },
        //支付状态轮询
        async TimeOUT(orderId) {
          var time = 1800; //30分钟换算成1800秒
          var temp = false;
          this.destoryId= setInterval(async ()=> {
            if(time<1){
                clearInterval(this.destoryId);
            }else{
              time = time - 5;
             try {
                  temp =  await this.refresh(orderId)
                  if(temp){
                    clearInterval(this.destoryId);
                    this.isCall = true;
                    this.$router.push({path: '/paySuccess', query: {"orderId":orderId}})
                  }
              } catch (err) {
                  console.log(err)
              }
              
            } 
          }, 5000);
        },
        callRefresh(orderId){
          this.refreshId= setInterval(()=> {
            this.callBack(orderId);
          }, 60000);
        }
      },
      components: {
        mallHeader,
        mallBread,
        mallFooter,
        vueQr,
        http
      }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
  .alipay-div{
      height: 624px;
      background: #FFFFFF;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
      margin-top: 0px;
      min-width: 1200px;    width: 1200px;margin: 0 auto;
  }
  .alipay-div-img{
      width: 34px;
      height: 34px;
      position: absolute;
      margin-top: 33px;
      margin-left: 31px;
  }
  .alipay-div-span-font{
      height: 25px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 20px;
      color: #333333;
      margin: 38px 30px 30px 70px;
      float: left;
  }
  .alipay-div-span-total{
      position: absolute;
      margin-left: 720px;
      margin-top: 38px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
  }
  .alipay-div-span-money{
      height: 20px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #FF620D;
      line-height: 20px;
      position: absolute; 
      margin-left: 835px;
      margin-top: 40px;
  }
  .alipay-div-span-line{
      border-top: 1px solid rgba(51, 51, 51, 0.15);
      width: 1190px;
      position: absolute;
      margin-left: -225px;
      margin-top: 92px;
  }
  .alipay-div-content-div{
      float: left;
      margin-top: 130px;
      margin-left: -160px;
      width: 272px;
      height: 41px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 26px;
  }
  .alipay-div-QRCode{
      width: 300px;
      height: 300px;
      margin-top: 205px;
      margin-left: -195px
  }
  .alipay-div-QRCode-box{
      height: 34px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgb(102, 102, 102);
      line-height: 20px;
      float: left;
      margin-top: 522px;
      margin-left: -125px;
  }
  .alipay-timeout-div{
      width: 300px;border: 1px solid #ffffff;
      height: 300px;
      margin-top: -305px;
      margin-left: -185px;
      opacity: 0.95;
  }
  .alipay-timeout-div-font{
      display: block;
      margin-left: 102px;
      margin-top: 112px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
  }
  .alipay-timeout-div-button{
      width: 120px;
      margin-top: 13px;
      margin-left: 90px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      height: 40px;
      background: #287EFF;
      border-radius: 4px;
  }
  .a{
    height: 34px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666;
    line-height: 20px;
    float: left;
    margin-top: 20px;
    margin-left: -115px;
  }
  .b{
    position: absolute;
    margin-top: 17px;
    margin-left: -75px;
    width: 126px;
    height: 34px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666;
    line-height: 20px;
  }
 .alipay-div-QRCode-font {
      position: absolute;
      margin-top: 520px;
      margin-left: -188px;
      width: 126px;
      height: 34px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
      line-height: 20px;
  }
  .alipay-div-line{
      border-right: 1px solid rgba(51, 51, 51, 0.15);
      height: 300px;
      position: absolute;
      margin-left: 150px;
      margin-top: 205px;
  }
  .alipay-div-index-img{
      margin: 163px 220px 30px 30px;
      float: right;
  }
  
</style>



// WEBPACK FOOTER //
// alipay.vue?5e450874